import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom'
import { marginRight } from 'styled-system';

const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
    },
    containerImages: {
      margin: '31px 0 10px 24px',
    },
    reference: {
        margin: '0 16px 0 0',
        '&:last-child': {
          margin: 0,
        }
      },
    img: {
      width: 24,
      height:24,
     
    },
  }));
const MediaSocialsComunity = () => {
    let location = useLocation();
    const classes = useStyles();

    return ( 
        <div className={classes.root}>

              <a 
                href={`https://www.facebook.com/sharer/sharer.php?u=${location.pathname}`}
                target="_blank" rel="noopener noreferrer"
                className={classes.reference}>
                <img
                  src='/img/socialNetworks/facebook.svg'
                  alt="facebook"
                  className={classes.img}
                />
              </a>
              <a 
                href={``}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/instagram.png'
                  alt="instagram"
                  className={classes.img}
                />
              </a>

              <a 
                href={`fb-messenger://share/?link=${location.pathname}`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.reference}
              >
                <img 
                  src='/img/socialNetworks/messenger.svg'
                  alt="linkedIn"
                  className={classes.img}
                />
              </a> 

              <a 
                href={`https://twitter.com/intent/tweet?&url=${location.pathname}`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/twitter.svg'
                  alt="twitter"
                  className={classes.img}
                />
              </a> 

              <a 
                href={`https://api.whatsapp.com/send?text=${location.pathname}`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.reference}
              >
                <img
                  src='/img/socialNetworks/you-tube.svg'
                  alt="youtube"
                  className={classes.img}
                />
              </a>
        </div>
     );
}
 
export default MediaSocialsComunity;

